export default __webpack_public_path__ + "static/media/call.871459cb.svg";